import React, { useState } from 'react'

import { ReactComponent as IconEdit } from 'assets/images/icons/edit-3.svg'
import FormDrawer from 'components/__new/common/form-drawer'
import EditWorkflow from './EditWorkflow';

const ViewWorkflowDetails = ({isOpen, setIsOpen, workflow, loading}) => {
    const [isOpenEditWorkflow, setIsOpenEditWorkflow] = useState(false);

    return (
        <>
            <EditWorkflow
                isOpen={isOpenEditWorkflow}
                setIsOpen={setIsOpenEditWorkflow}
                workflow={workflow}
            />

            <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="View Details"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className='mt-3'/>

                    <div className="w-full my-7">
                        <div className="my-7 flex items-center justify-end space-x-2 cursor-pointer text-ep-primary-600"
                            onClick={() => setIsOpenEditWorkflow(true)}
                        >
                            <IconEdit />
                            <span className='underline'>Edit Workflow</span>
                        </div>
                        
                        <div className='p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Workflow Details</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className='flex gap-6'>
                                    <div className='flex flex-col gap-6'>
                                        <div>
                                            <div className='text-[#718096]'>Workflow Name</div>
                                            <div>{workflow?.title}</div>
                                        </div>
                                        <div>
                                            <div className='text-[#718096]'>Workflow Description</div>
                                            <div>{workflow?.description}</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='mb-1 text-[#718096]'>Request Type</div>
                                        <div className='capitalize'>{workflow?.type}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Workflow Stages</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className='flex gap-6'>
                                    {workflow?.WorkflowStages?.length > 0 && workflow?.WorkflowStages?.map((stage, index) => (
                                        <div key={index}>
                                            <div className='bg-[#F9F5FF] text-ep-purple-100 inline-block uppercase py-1 px-4 rounded-full mb-4'>Stage {index + 1}</div>
                                            <div className='flex flex-col gap-6'>
                                                <div>
                                                    <div className='text-[#718096]'>Stage Name</div>
                                                    <div>{stage?.name}</div>
                                                </div>
                                                <div>
                                                    <div className='text-[#718096]'>Assigned Approval Role</div>
                                                    <div>{stage?.approvalRole?.name}</div>
                                                </div>
                                                {/* <div>
                                                    <div className='text-[#718096]'>Initiator</div>
                                                    <div>{stage?.initiator}</div>
                                                </div> */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FormDrawer>
        
        </>
    )
}



export default ViewWorkflowDetails;